import { LEFT_MENU_OPENED } from 'constants/mixpanel';
import { WIDGET_MENU_OPTIONS } from 'types/WidgetMenu.types';

/*
 * This function returns the left menu item event type from the widget menu option
 *  @param itemId {WIDGET_MENU_OPTIONS}
 *  @returns {string | null}
 */
export const handleSidebarEventType = (itemId: WIDGET_MENU_OPTIONS) => {
  switch (itemId) {
    case WIDGET_MENU_OPTIONS.BRAND_KIT:
      return LEFT_MENU_OPENED.type.BrandKit;
    case WIDGET_MENU_OPTIONS.TEMPLATES:
      return LEFT_MENU_OPENED.type.Template;
    case WIDGET_MENU_OPTIONS.TEXT:
      return LEFT_MENU_OPENED.type.Text;
    case WIDGET_MENU_OPTIONS.SHAPES:
      return LEFT_MENU_OPENED.type.Shape;
    case WIDGET_MENU_OPTIONS.ICONS:
      return LEFT_MENU_OPENED.type.Icon;
    case WIDGET_MENU_OPTIONS.PHOTOS:
      return LEFT_MENU_OPENED.type.Image;
    case WIDGET_MENU_OPTIONS.UPLOAD:
      return LEFT_MENU_OPENED.type.Upload;
    case WIDGET_MENU_OPTIONS.CHARTS:
      return LEFT_MENU_OPENED.type.Chart;
    case WIDGET_MENU_OPTIONS.MAPS:
      return LEFT_MENU_OPENED.type.Map;
    case WIDGET_MENU_OPTIONS.ELEMENTS:
      return LEFT_MENU_OPENED.type.Elements;
    default:
      return null;
  }
};
